import * as React from 'react';
import { ToastOptions, toast, TypeOptions } from 'react-toastify';
import classNames from 'classnames';
import 'react-toastify/dist/ReactToastify.css';
/**
 * Show alert as a toast
 * @param errorMsg The text to be printed on the alert toast
 * @param type The type of the toast
 * @param headerMsg The header of the alert toast
 * @param options additional options such as 'autoClose' | 'position'
 */
export default function alertToast(
	errorMsg: React.ReactNode = '',
	type: TypeOptions = 'info',
	headerMsg: React.ReactNode = '',
	options: ToastOptions = {},
) {
	toast(
		<div className="alert__container">
			<div className={`${type}-icon icon`} />
			<div>
				{headerMsg !== '' && <h6>{headerMsg}</h6>}
				{errorMsg !== '' && <p>{errorMsg}</p>}
			</div>
		</div>,
		{
			className: classNames('alert', `alert__${type}`),
			type,
			hideProgressBar: false,
			autoClose: 3000,
			icon: false,
			closeOnClick: true,
			...options,
		},
	);
}
